import {useEffect} from "react";
import {getCommonIndex} from "../service";
import {useDispatch, useSelector} from "react-redux";
import {State} from "../store/reducer";
import {commonImagesAction} from "../store/actions";

export default () => {

    const banner = useSelector<State,State['commonImages']>(state => state.commonImages)
    const dispatch = useDispatch()

    useEffect(() => {
        if(!banner){
            getCommonIndex().then(res => {
                if (res.code === 1) {
                    dispatch(commonImagesAction(res.data))
                }
            })
        }

    }, [])

    return banner
}
